﻿import React, { useState, useCallback } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { EditType } from '../models/enums';
import { NewUser } from '../models/new-user';
import { UserGroup } from '../models/user-group';

import DataGrid, {
    Column,
    Selection,
    Editing,
    Paging,
    Toolbar,
    Item as ToolBarItem,
    Button as ColumnButton    
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import TagBox, { TagBoxTypes } from 'devextreme-react/tag-box';
import Guid from 'devextreme/core/guid';

export interface Props {
    users: NewUser[]; 
    userGroups: UserGroup[];
    onClose?: () => void;
}

export default function AddUsersComponent(props: Props) {
    const [newUsers, setNewUsers] =
        useState<NewUser[]>([]);

        //needed bcause new row does not get added to datagrid until validation at leaving row
    const [addedUsers, setAddedUsers] =
        useState<NewUser[]>([]);
        
    const [selectedNewUser, setSelectedNewUser] =
        useState<NewUser>();

        
    return (
        <div>

            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">
                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height={'1.8rem'}
                        onClick={onSaveClick} />

                    <Button id="saveAndCloseButton" text="Save and Close" icon="exportselected" type="success"
                        className="pw-button"
                        hint="save changes then close dialog"
                        height={'1.8rem'}
                        onClick={onSaveAndCloseClick} />

                    <Button id="cancelButton" text="Cancel" icon="close" type="normal"
                        className="pw-button"
                        hint="cancel and lose any changes"
                        height={'1.8rem'}
                        onClick={onCancelClick} />
                </div>
            </div>

            <div className="pw-comp-row">
                <DataGrid
                    height="20rem"
                    keyExpr="userId"
                    dataSource={newUsers ? newUsers : []}
                    onSelectionChanged={newUsersSelectionChanged}
                    onRowValidating={onNewUsersRowValidating}
                    onCellClick={onNewUsersCellClick}
                    onInitNewRow={onInitNewUserRow}
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <Paging enabled={false} />
                    <Selection mode={'single'} />
                    
                    <Column type="buttons" width='4rem'>
                        <ColumnButton name="delete" onClick={onRowDeleteClick} />
                    </Column>

                    <Column dataField={'userName'} width='10%' />
                    <Column dataField={'domainUserName'} width='10%' />
                    <Column dataField={'lastName'} width='10%' />
                    <Column dataField={'firstName'} width='10%' />
                    <Column dataField={'email'} width='25%' />
                    <Column dataField={'roleList'}
                        cellTemplate={userGroupCellTemplate}
                        editCellComponent={userGroupTagBoxComponent}
                        width='45%' />

                    <Editing
                        mode="cell"
                        useIcons={true}
                        allowAdding={true}
                        allowDeleting={true}
                        allowUpdating={true} />

                    <Toolbar>
                        <ToolBarItem location='before' />
                        <ToolBarItem location='after' name="addRowButton" />
                        
                    </Toolbar>

                </DataGrid>
            </div>

            <div className="pw-left-grow-2 pw-margin-bottom-05">
                <div>LEFT



                </div>

                <div>RIGHT</div>

            </div>
        </div>
    );

    function onSaveClick() {
        saveNewUsers();
    }

    async function onSaveAndCloseClick() {
        await saveNewUsers()
            .then(() => {
                if (props.onClose)
                    props.onClose();
            })
    }

    function onCancelClick() {
        if (props.onClose)
            props.onClose();
    }


    function onNewUsersCellClick(e: any) {
        console.log("onNewUsersCellClick");
        console.log(e);

        if (e.row && e.row.data)
            setSelectedNewUser(e.row.data);
    }

    //needed?
    function newUsersSelectionChanged(e: any) {
        console.log("newUserSelectionChanged");
        console.log(e);

        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedNewUser(e.selectedRowsData[0]);
        }
    }

    function onInitNewUserRow(e:any) {
        let newUser: NewUser = {
            userId: new Guid().toString(),
            userName: '',
            domainUserName: '',
            active: true
        };

        //need to add to separate list
        let editedAddedUsers = [...addedUsers];
        editedAddedUsers.push(newUser);
        setAddedUsers(editedAddedUsers);

        e.data = newUser;
    }

    function onNewUsersRowValidating(e: any) {
        //todo: grab any data from AddedUsers list

        if (e.newData) {
            let matchingAddedUser = addedUsers.find(u => u.userId === e.newData.userId);

            if (matchingAddedUser) {
                e.newData.userGroups = matchingAddedUser.userGroups;

                //TODO: remove added user?
            }

            console.log("e.newData:");
            console.log(e.newData);
            

        }
        else {



        }



    }

    function onRowDeleteClick(e: any) {
        console.log("onRowDeleteClick");
        console.log(e);

        if (e.row && e.row.data) {
            let currentUsers = newUsers.filter(u => u.userId !== e.row.data.userId);

            if (currentUsers)
                setNewUsers(currentUsers);
            else
                setNewUsers([]);
        }
    }

    async function saveNewUsers() {
        console.log("newUsers:");
        console.log(newUsers);



    }


    function userGroupTagBoxComponent() {
        const onValueChanged = useCallback((e: TagBoxTypes.ValueChangedEvent) => {
            console.log("sel changes-->");
            console.log(e);

            if (selectedNewUser) {
                let editedNewUsers = [...newUsers];

                console.log(205)
                console.log(newUsers);

                let matchingNewUser = editedNewUsers.find(u => u.userId === selectedNewUser.userId)

                if (matchingNewUser) {
                    const matchingUserGroups = getMatchingUserGroups(e.value);
                    matchingNewUser.userGroups = matchingUserGroups;

                    setNewUsers(editedNewUsers);
                }
                else {
                    console.log(220);

                    let editedAddedUsers = [...addedUsers];

                    let matchingAddedUser =  editedAddedUsers.find(u => u.userId === selectedNewUser.userId)

                    if (matchingAddedUser) {
                        const matchingUserGroups = getMatchingUserGroups(e.value);
                        matchingAddedUser.userGroups = matchingUserGroups;

                        setNewUsers(editedAddedUsers);
                    }
                }
            }    

            //props.data.setValue(e.value);
        }, [props]);

        const onSelectionChanged = useCallback(() => {
            //props.data.component.updateDimensions();
        }, [props]);

        return (
            <TagBox
                dataSource={props.userGroups}
                valueExpr="userGroupId"
                displayExpr="groupName"
                showSelectionControls={true}
                showMultiTagOnly={false}
                applyValueMode="useButtons"
                searchEnabled={true}
                onValueChanged={onValueChanged}
                onSelectionChanged={onSelectionChanged} />
        );

        //defaultValue={props.data.value}

    };

    function getMatchingUserGroups(userGroupIds?: string[]) {
        if (!userGroupIds)
            return;

        let userUserGroups: UserGroup[] = [];

        for (let userGroupId of userGroupIds) {

            const matchingUserGroup = props.userGroups.find(ug => ug.userGroupId === userGroupId);

            if (matchingUserGroup)
                userUserGroups.push(matchingUserGroup);
        }

        return userUserGroups;
    }

    function userGroupCellTemplate(container: { textContent: any; title: any; }, options) {
        console.log("userGroupCellTemplate");
        console.log(options);

        if (options && options.data && options.data.userGroups) {
            return (
                <TagBox
                    dataSource={props.userGroups}
                    valueExpr="userGroupId"
                    displayExpr="groupName"
                    showSelectionControls={true}
                    showMultiTagOnly={false}
                    applyValueMode="useButtons"
                    searchEnabled={true}
                    value={options.data.userGroups} />
            );
        }
        else
            return <div>NA</div>;

    }
}